import React, { useContext } from 'react'
import { GlobalContext } from 'globalContext'
import { Route, Redirect } from 'react-router-dom'

export default function RestrictedRoute({ component: Component, render, ...otherProps }) {
    const [{ user }] = useContext(GlobalContext)
    const routerProps = {}

    if ('restricted' in otherProps) {
        const splited = otherProps.restricted.split('>')
        if (user.permissions[splited[0]].allow.length && user.permissions[splited[0]].allow.includes(splited[1]))
            routerProps['render'] = Component ? props => <Component {...props} /> : render
        else
            routerProps['render'] = () => <Redirect to="/nao-autorizado" />
    } else 
        routerProps['render'] = Component ? props => <Component {...props} /> : render

    return <Route {...otherProps} {...routerProps} />
}
